<!--
 * @Description: 404
 * @Version: 2.0
 * @Autor: daikeyi
 * @Date: 2020-06-05 15:25:04
 * @LastEditors: daikeyi
 * @LastEditTime: 2021-01-20 11:34:44
-->
<template>
    <div id="page_Container">
        <div id='main-container' class="main-container">
            <div id="notFound">
                <div class="center">
                    <img :src="mainImg" alt="">
                    <p>咦？链接失效了呢</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            mainImg: require('@/assets/img/notFound/404@3x.png')
        };
    }
};
</script>

<style lang="scss">
    #notFound {
        .center {
            width: 205px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            img {
                width: 100%;
            }
            p {
                color: #999;
                font-size: 14px;
                text-align: center;
            }
        }

    }
</style>
